import { HelmetDexteel } from "@dexteel/mesf-core";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Logbook } from "./components/Logbook";

export const routeLogbook = "/logbook";

export const LogbookPage = () => {
	return (
		<>
			<HelmetDexteel title="Logbook" />
			<Logbook />
		</>
	);
};

// Old Logbook Entry / Logbook Report addresses (bookmarks, shared links)
export const LegacyLogbookRedirect = ({
	mode,
}: {
	mode: "shift" | "period";
}) => {
	const { search } = useLocation();
	const { shiftId } = useParams();
	const params = new URLSearchParams(search);
	if (mode === "shift") {
		params.set("mode", "shift");
		if (shiftId) params.set("shiftId", shiftId);
	}
	const query = params.toString();
	return <Navigate to={`${routeLogbook}${query ? `?${query}` : ""}`} replace />;
};
